import { useState } from "react";
import { X, Plus, Check } from "lucide-react";
import { postProjeto, putProjeto } from "../../api";

function Campo({ label, children, C }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: C.muted }}>
        {label}
      </label>
      {children}
    </div>
  );
}

function inputStyle(C) {
  return {
    background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8,
    padding: "9px 12px", fontSize: 13, color: C.text, fontFamily: "inherit", outline: "none", width: "100%",
  };
}

// Cadastro simples de Projeto — compartilhado por Alocação de Pessoal e Custos Gerais por
// Projeto. Cadastro novo e independente: não linka com o nome_projeto solto de Faturamento
// Bruto/Novas Vendas (ver plano da feature).
export default function ProjetosCrudModal({ C, projetos, onClose, onProjetosChange }) {
  const [novoNome, setNovoNome] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [nomeEditando, setNomeEditando] = useState("");

  async function criar() {
    if (!novoNome.trim()) return;
    setSalvando(true);
    setErro("");
    try {
      await postProjeto({ nome: novoNome.trim(), ativo: true });
      setNovoNome("");
      await onProjetosChange();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  }

  async function salvarRenomear(id) {
    if (!nomeEditando.trim()) return;
    try {
      await putProjeto(id, { nome: nomeEditando.trim() });
      setEditandoId(null);
      await onProjetosChange();
    } catch (e) {
      setErro(e.message);
    }
  }

  async function alternarAtivo(projeto) {
    try {
      await putProjeto(projeto.id, { ativo: !projeto.ativo });
      await onProjetosChange();
    } catch (e) {
      setErro(e.message);
    }
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 60, padding: 16 }}>
      <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 24, width: "100%", maxWidth: 460, boxShadow: "0 24px 64px rgba(0,0,0,0.4)", maxHeight: "90vh", overflowY: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
          <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: C.text }}>Gerenciar Projetos</p>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: C.muted, display: "flex" }}>
            <X size={20} />
          </button>
        </div>

        {erro && (
          <div style={{ background: `${C.danger}18`, border: `1px solid ${C.danger}`, color: C.danger, borderRadius: 8, padding: "8px 12px", fontSize: 12, marginBottom: 12 }}>
            {erro}
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 320, overflowY: "auto" }}>
          {projetos.length === 0 && (
            <div style={{ color: C.muted, fontSize: 13, textAlign: "center", padding: 16 }}>Nenhum projeto cadastrado ainda.</div>
          )}
          {projetos.map((p) => (
            <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 8, border: `1px solid ${C.border}`, borderRadius: 10, padding: "8px 10px" }}>
              {editandoId === p.id ? (
                <>
                  <input autoFocus value={nomeEditando} onChange={(e) => setNomeEditando(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && salvarRenomear(p.id)}
                    style={{ ...inputStyle(C), padding: "6px 8px" }} />
                  <button onClick={() => salvarRenomear(p.id)} style={{ background: "none", border: "none", cursor: "pointer", color: C.success, display: "flex" }}>
                    <Check size={16} />
                  </button>
                </>
              ) : (
                <>
                  <span
                    onClick={() => { setEditandoId(p.id); setNomeEditando(p.nome); }}
                    style={{ flex: 1, fontSize: 13, color: p.ativo ? C.text : C.muted, cursor: "pointer", opacity: p.ativo ? 1 : 0.6 }}
                    title="Clique para renomear"
                  >
                    {p.nome}
                  </span>
                  <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: C.muted, cursor: "pointer" }}>
                    <input type="checkbox" checked={p.ativo} onChange={() => alternarAtivo(p)} />
                    Ativo
                  </label>
                </>
              )}
            </div>
          ))}
        </div>

        <Campo label="Novo projeto" C={C}>
          <div style={{ display: "flex", gap: 8 }}>
            <input value={novoNome} onChange={(e) => setNovoNome(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && criar()}
              placeholder="Nome do projeto" style={inputStyle(C)} />
            <button onClick={criar} disabled={salvando || !novoNome.trim()}
              style={{ display: "flex", alignItems: "center", gap: 6, background: C.brand, border: "none", borderRadius: 8, padding: "9px 14px", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", opacity: salvando || !novoNome.trim() ? 0.6 : 1 }}>
              <Plus size={15} /> Criar
            </button>
          </div>
        </Campo>
      </div>
    </div>
  );
}
